import 'css-chunksrc/client/scenes/wbsConfiguration/form/columns/styles.scss';export default {
  "columns": "_columns_x42j0_1",
  "columnWrapper": "_columnWrapper_x42j0_7",
  "column": "_column_x42j0_1",
  "iconBox": "_iconBox_x42j0_27",
  "icon": "_icon_x42j0_27",
  "columnIcon": "_columnIcon_x42j0_45",
  "hidden": "_hidden_x42j0_54"
};